<section *ngIf="platform.streamingProtocol === 1">
  <header>Choose Edge Servers:</header>
  <div class="edge-servers-choose">
    <span class="label"> Edge Server: </span>
    <icn-dropdown
      [(selectedValues)]="platform.edgeServerIds"
      [listDown]="true"
      [allowMultiple]="true"
      (selectedValuesChange)="onEdgeServerChanged()"
    >
      <icn-dropdown-item
        *ngFor="let edgeServer of allEdgeServers"
        [title]="edgeServer.name"
        [value]="edgeServer.id"
        [showSettings]="false"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
  <header>Choose your channel's language:</header>
  <div class="audio-choose">
    <span class="label"> AUDIO: </span>
    <icn-dropdown
      [(selectedValues)]="platform.audioLanguages"
      [listDown]="true"
      [allowMultiple]="true"
    >
      <icn-dropdown-item
        *ngFor="let audio of languages"
        [title]="audio.name"
        [value]="audio.code"
        [showSettings]="true"
        (onSettingsClicked)="onSettingsClicked()"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
  <div class="subtitles-choose" *ngIf="!burnSubtitlesToVideo">
    <span class="label"> EXTRA SUBTITLES: </span>
    <icn-dropdown
      [allowMultiple]="true"
      [listDown]="true"
      [selectedValues]="getDvbSubtitleLanguages()"
      (selectedValuesChange)="onDvbSubtitleLanguagesChange($event)"
    >
      <icn-dropdown-item
        *ngFor="let language of languages"
        [value]="language.code"
        [title]="language.name"
        [titleTemplateRef]="title"
        [showSettings]="false"
        (onSettingsClicked)="onSettingsClicked()"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
  <header>HLS Settings:</header>
  <div class="hls-settings">
    <div class="label">RESOLUTION:</div>
    <icn-dropdown
      [medium]="true"
      [(selectedValue)]="platform.hlsSettings.resolution"
    >
      <icn-dropdown-item title="1080p" [value]="1080"></icn-dropdown-item>
      <icn-dropdown-item title="720p" [value]="720"></icn-dropdown-item>
      <icn-dropdown-item title="360p" [value]="360"></icn-dropdown-item>
    </icn-dropdown>
  </div>
  <div class="hls-settings">
    <div class="label">FPS:</div>
    <icn-dropdown [short]="true" [(selectedValue)]="platform.hlsSettings.fps">
      <icn-dropdown-item title="23.976" [value]="23.976"></icn-dropdown-item>
      <icn-dropdown-item title="24" [value]="24"></icn-dropdown-item>
      <icn-dropdown-item title="25" [value]="25"></icn-dropdown-item>
      <icn-dropdown-item title="29.97" [value]="29.97"></icn-dropdown-item>
      <icn-dropdown-item title="30" [value]="30"></icn-dropdown-item>
      <icn-dropdown-item title="50" [value]="50"></icn-dropdown-item>
      <icn-dropdown-item title="59.94" [value]="59.94"></icn-dropdown-item>
      <icn-dropdown-item title="60" [value]="60"></icn-dropdown-item>
    </icn-dropdown>
  </div>
</section>
<section *ngIf="platform.streamingProtocol === 2">
  <header>Choose Edge Servers:</header>
  <div class="edge-servers-choose">
    <span class="label"> Edge Server: </span>
    <icn-dropdown
      [(selectedValues)]="platform.edgeServerIds"
      [listDown]="true"
      [allowMultiple]="true"
      (selectedValuesChange)="onEdgeServerChanged()"
    >
      <icn-dropdown-item
        *ngFor="let edgeServer of allEdgeServers"
        [title]="edgeServer.name"
        [value]="edgeServer.id"
        [showSettings]="false"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
  <header>Choose your channel's language:</header>
  <div class="audio-settings">
    <span class="label"> AUDIO: </span>
    <icn-dropdown
      [medium]="true"
      [(selectedValues)]="platform.audioLanguages"
      [allowMultiple]="true"
    >
      <icn-dropdown-item
        *ngFor="let language of languages"
        [title]="language.name"
        [value]="language.code"
      >
      </icn-dropdown-item>
    </icn-dropdown>
    <div class="subtitles-choose" *ngIf="!burnSubtitlesToVideo">
      <span class="label label2"> DVB SUBTITLES: </span>
      <icn-dropdown
        [allowMultiple]="true"
        [showSettingsIcon]="true"
        [selectedValues]="getDvbSubtitleLanguages()"
        (settingsIconClicked)="onLanguageSettingsClicked($event)"
        (selectedValuesChange)="onDvbSubtitleLanguagesChange($event)"
      >
        <ng-template ngFor let-language [ngForOf]="languages">
          <icn-dropdown-item
            [value]="language.code"
            [title]="language.name"
            [titleTemplateRef]="title"
          ></icn-dropdown-item>
          <ng-template #title>
            {{ language.name }}

            <pop-over
              #dvbSubtitleSettingsPopover
              [my]="'top left'"
              [at]="'top right'"
              [y-offset]="-76"
              [x-offset]="20"
              [content-class]="'lang-code-' + language.code"
              *ngIf="isSubtitleLanguageChecked(language.code)"
            >
              <div class="subtitles-font-popover">
                <div class="triangle-with-shadow"></div>
                <div class="header-close-container">
                  <header>{{ language.name }} Subtitles Settings</header>
                  <div
                    class="x-sign"
                    [inlineSVG]="closeIcon"
                    (click)="
                      dvbSubtitleSettingsPopover.hide();
                      $event.stopImmediatePropagation()
                    "
                  ></div>
                </div>
                <div class="field">
                  <span class="label">FONT TYPE:</span>
                  <icn-dropdown
                    #fontTypeDropdown
                    [(selectedValue)]="
                      platform.dvbSubtitles[language.code].fontId
                    "
                  >
                    <icn-dropdown-item
                      *ngFor="let font of fonts"
                      [title]="font.name"
                      [value]="font.id"
                    >
                    </icn-dropdown-item>
                  </icn-dropdown>
                </div>
                <div class="field">
                  <span class="label">Subtitle start position from top:</span>
                  <div class="number-input">
                    <icn-number-input
                      #subtitleStartPositionFromTop
                      [min]="0"
                      [max]="subtitleEndPositionFromTop.value - 0.5"
                      [maxLength]="3"
                      [sign]="'%'"
                      [step]="0.5"
                      [contentEditable]="false"
                      [value]="
                        platform.dvbSubtitles[language.code]
                          .subtitleStartPositionFromTop
                      "
                    ></icn-number-input>
                  </div>
                </div>
                <div class="field">
                  <span class="label">Subtitle end position from top:</span>
                  <div class="number-input">
                    <icn-number-input
                      #subtitleEndPositionFromTop
                      [min]="subtitleStartPositionFromTop.value + 0.5"
                      [max]="100"
                      [sign]="'%'"
                      [maxLength]="3"
                      [step]="0.5"
                      [contentEditable]="false"
                      [value]="
                        platform.dvbSubtitles[language.code]
                          .subtitleEndPositionFromTop
                      "
                    ></icn-number-input>
                  </div>
                </div>
                <ichannel-button
                  [label]="'Save'"
                  [theme]="'DARK'"
                  (click)="
                    onSubtitleSettingsSave(
                      dvbSubtitleSettingsPopover,
                      language.code,
                      fontTypeDropdown.selectedValue,
                      subtitleStartPositionFromTop.value,
                      subtitleEndPositionFromTop.value
                    )
                  "
                >
                </ichannel-button>
              </div>
            </pop-over>
          </ng-template>
        </ng-template>
      </icn-dropdown>
    </div>
  </div>
  <header>PUSH Settings:</header>

  <div>
    <div class="label">FORMAT:</div>
    <icn-dropdown
      [(selectedValue)]="platform.pushSettings.format"
      (selectedItemChange)="onChannelFormatChange($event)"
      *ngIf="channelDistributionFormats"
    >
      <icn-dropdown-item
        *ngFor="let format of channelDistributionFormats.formats"
        [title]="format.displayName"
        [value]="format.name"
        [item]="format"
      ></icn-dropdown-item>
    </icn-dropdown>
  </div>

  <div *ngIf="!isChannelPushSrtFormat">
    <div class="label textarea-label">URL:</div>
    <textarea
      [placeholder]="getFormatUrlPlaceholder()"
      [(ngModel)]="platform.pushSettings.url"
    ></textarea>
  </div>
  <div *ngIf="isChannelPushSrtFormat" class="srt-settings">
    <div>
      <div class="srt-field">
        <span class="label">Push Mode:</span>
        <input
          type="checkbox"
          [(ngModel)]="platform.pushSettings.pushMode"
          class="cursor-pointer align-middle"
        />
      </div>
    </div>
    <div>
      <div class="srt-field" *ngIf="platform.pushSettings.pushMode">
        <span class="label">Push Address:</span>
        <input type="text" [(ngModel)]="platform.pushSettings.pushAddress" />
      </div>
    </div>
    <div>
      <div class="srt-field">
        <span class="label"> Port Number: </span>
        <div
          *ngIf="isChannelPushSrtFormat && platform.pushSettings.pushMode"
          class="srt-port-number"
        >
          <input
            type="number"
            min="0"
            max="65535"
            [(ngModel)]="platform.pushSettings.portNum"
            (blur)="srtPortNumberChanged($event)"
          />(0 - 65535)
        </div>
        <div
          *ngIf="isChannelPushSrtFormat && !platform.pushSettings.pushMode"
          class="srt-port-number"
        >
          <input
            type="number"
            min="40000"
            max="50000"
            [(ngModel)]="platform.pushSettings.portNum"
            (blur)="srtPortNumberChanged($event)"
          />(40000 - 50000)
        </div>
      </div>
    </div>

    <div>
      <div class="srt-field">
        <span class="label">Pass Phrase:</span>
        <input
          type="text"
          [(ngModel)]="platform.pushSettings.passPhrase"
          minlength="10"
          maxlength="80"
          (blur)="onPassPhraseChanged($event)"
        />(10-80) Characters
      </div>
    </div>
    <div>
      <div class="srt-field">
        <span class="label">Latency MS:</span>
        <input
          type="number"
          min="0"
          max="100000"
          [(ngModel)]="platform.pushSettings.latencyMs"
          (blur)="onLatencyMsChanged($event)"
        />
      </div>
    </div>
  </div>

  <div [hidden]="!platform.pushSettings.format">
    <div class="label">CODEC SETTINGS:</div>
    <div class="codec-dropdown">
      <icn-dropdown
        [large]="true"
        [(selectedValue)]="platform.pushSettings.codecId"
      >
        <ng-template
          ngFor
          let-codec
          [ngForOf]="channelCodecs"
          [ngForTrackBy]="trackById"
        >
          <icn-dropdown-item
            [value]="codec.id"
            [titleTemplateRef]="title"
          ></icn-dropdown-item>
          <ng-template #title>
            {{ codec.name }}
            <div
              class="clickable inline"
              (click)="editCodec(codec, platform.pushSettings.format)"
            >
              {{ codec.isDefault ? "View" : "Edit" }}
            </div>
          </ng-template>
        </ng-template>
        <div class="clickable new" (click)="addNewCodec()">+ Add New</div>
      </icn-dropdown>
    </div>
  </div>
</section>

<icn-edit-codec-popup
  *ngIf="isAddOrEditCodec"
  [codec]="codecToEdit"
  [formatDetails]="formatToEdit"
  (close)="isAddOrEditCodec = false"
  (save)="onCodecSave($event)"
></icn-edit-codec-popup>
